import 'antd/dist/reset.css';
import { useMemo, useState } from 'react';
import { AppContext, AuthContext } from './common/constants';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import {
  AjoutAdministrateur, AjoutCategorie, AjoutSite, Categories, Chauffeurs, DemandesAssistances,
  DetailChauffeur, DetailPartenaire, DetailSite, DetailSouscripteur, HistoriqueNumeros, HistoriquePoints,
  HistoriquePromotions, HistoriqueSosCredits, HistoriqueTransferts,
  HistoriqueVehiculesModifies, Home, ListeDesAdministeurs, Login, MainLayout,
  MiscError, Operations, Partenaires, Privacy, Profile, Sites, Souscripteurs, Vehicules, Wallet
} from './pages';
import ProtectedRoute from './components/protectedRoute';
import { UseAuthentification } from './common/hooks';
import AppSplash from './components/appSplash';

function App() {
  const [appStore, setAppState] = useState({});
  const auth = UseAuthentification();
  const dispatcher = (newState) => setAppState(s => ({ ...s, ...newState }));

  const routers = useMemo(() => createBrowserRouter([
    {
      path: "/dashboard",
      element: <MainLayout />,
      errorElement: <MiscError />,
      //on enlève le loader bloquant ici
      children: [
        { path: "", element: <ProtectedRoute perm="dashboard:view"><Home /></ProtectedRoute>, errorElement: <MiscError /> },
        { path: "categories", element: <ProtectedRoute perm="categories:read"><Categories /></ProtectedRoute>, errorElement: <MiscError /> },
        { path: "ajouter-categorie", element: <ProtectedRoute perm="categories:create"><AjoutCategorie /></ProtectedRoute>, errorElement: <MiscError /> },

        { path: "partenaires", element: <ProtectedRoute perm="partners:read"><Partenaires /></ProtectedRoute>, errorElement: <MiscError /> },
        { path: "partenaire/:id", element: <ProtectedRoute perm="partners:read"><DetailPartenaire /></ProtectedRoute>, errorElement: <MiscError /> },

        { path: "chauffeurs", element: <ProtectedRoute perm="drivers:read"><Chauffeurs /></ProtectedRoute>, errorElement: <MiscError /> },
        { path: "chauffeur/:id", element: <ProtectedRoute perm="drivers:read"><DetailChauffeur /></ProtectedRoute>, errorElement: <MiscError /> },

        { path: "profile", element: <Profile />, errorElement: <MiscError /> },

        { path: "historique-numeros", element: <ProtectedRoute perm="userPhone.history:read"><HistoriqueNumeros /></ProtectedRoute>, errorElement: <MiscError /> },
        { path: "historique-vehicules-modifies", element: <ProtectedRoute perm="vehicleChanges.history:read"><HistoriqueVehiculesModifies /></ProtectedRoute>, errorElement: <MiscError /> },
        { path: "historique-transferts", element: <ProtectedRoute perm="transfers.history:read"><HistoriqueTransferts /></ProtectedRoute>, errorElement: <MiscError /> },
        { path: "historique-sos-credit", element: <ProtectedRoute perm="soscredit.history:read"><HistoriqueSosCredits /></ProtectedRoute>, errorElement: <MiscError /> },

        { path: "demandes-assistances", element: <ProtectedRoute anyOf={['assistance:read','assistance:update']}><DemandesAssistances /></ProtectedRoute>, errorElement: <MiscError /> },

        { path: "gestion-admins", element: <ProtectedRoute anyOf={['users:read']}><ListeDesAdministeurs /></ProtectedRoute>, errorElement: <MiscError /> },
        { path: "ajouter-admin", element: <ProtectedRoute anyOf={['users:create']}><AjoutAdministrateur /></ProtectedRoute>, errorElement: <MiscError /> },

        { path: "historique-points", element: <ProtectedRoute perm="finance:read"><HistoriquePoints /></ProtectedRoute>, errorElement: <MiscError /> },
        { path: "wallet", element: <ProtectedRoute anyOf={['finance:read','finance:update']}><Wallet /></ProtectedRoute>, errorElement: <MiscError /> },

        { path: "vehicules", element: <ProtectedRoute perm="vehicles:read"><Vehicules /></ProtectedRoute>, errorElement: <MiscError /> },

        { path: "historique-promotions", element: <ProtectedRoute perm="promotions:read"><HistoriquePromotions /></ProtectedRoute>, errorElement: <MiscError /> },
        { path: "toutes-operations", element: <ProtectedRoute perm="operations:read"><Operations /></ProtectedRoute>, errorElement: <MiscError /> },
        { path: "sites", element: <Sites />, errorElement: <MiscError /> },
        { path: "site/:id", element: <DetailSite />, errorElement: <MiscError /> },
        { path: "ajout-site", element: <AjoutSite />, errorElement: <MiscError /> },

        { path: "souscripteurs", element: <Souscripteurs />, errorElement: <MiscError /> },
        { path: "souscripteur/:id", element: <DetailSouscripteur />, errorElement: <MiscError /> },

      ],
    },
    { path: "/", element: <Login />, errorElement: <MiscError /> },
    { path: "/privacy", element: <Privacy />, errorElement: <MiscError /> },
  ]), [auth]);

  //pas d’écran blanc : on affiche un splash le temps d’initialiser l’auth
  if (!auth.initialized) {
    return <AppSplash />;
  }

  return (
    <div className="App">
      <AuthContext.Provider value={auth}>
        <AppContext.Provider value={{ store: appStore, dispatcher }}>
          {/*couvre aussi les loaders éventuels sur d’autres routes */}
          <RouterProvider router={routers} fallbackElement={<AppSplash />} />
        </AppContext.Provider>
      </AuthContext.Provider>
    </div>
  );
}

export default App;
